import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './MFSynopsis.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function MFSynopsis() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "MfFundProfile";

        fetch(`${getUrl}/100`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "MF")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>MF Synopsis</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='syno-loser-sc'>
                            <div className='syno-header'>
                                <h2><span>MF Synopsis</span></h2>
                            </div>
                            <MarketMF optionValue="MF Synopsis" />
                            <div className='syno-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left' >Fund House</th>
                                            <th className='text-right'>Incorp Date</th>
                                            <th className='text-left' >Fund Type</th>
                                            <th className='text-right' >Open Ended<br></br> Schemes</th>
                                            <th className='text-right' >Close Ended<br></br> Schemes</th>
                                            <th className='text-right' >Interval<br></br> Schemes</th>
                                            <th className='text-right' >Total Assets<br></br>(Rs.CR)</th>
                                            <th className='text-right' >As On Date</th>
                                            <th className='text-left' >Address</th>

                                        </tr>

                                    </thead>

                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ LNAME, STARTED_ON, FUND_TYPE, osch, csch, isch, SumOfTOTNAV, dateas, address }) => (
                                                <>

                                                    <tr>
                                                        <td className="text-left"> {LNAME}</td>
                                                        <td className="text-right"> {(STARTED_ON != null) ? format(parseISO(STARTED_ON), 'dd-MMM-yyyy') : 0}</td>
                                                        <td className="text-left">{FUND_TYPE}</td>
                                                        <td className="text-right">{osch}</td>
                                                        <td className="text-right">{csch}</td>
                                                        <td><div className="text-right">{(isch != null) ? isch : 0}</div></td>
                                                        <td><div className="text-right"> {SumOfTOTNAV != null ? SumOfTOTNAV.toFixed(2) : 0} </div></td>
                                                        <td className="text-right"> {(dateas != null) ? format(parseISO(dateas), 'dd-MMM-yyyy') : 0}</td>
                                                        <td className="text-left">{address}</td>
                                                    </tr>

                                                </>
                                            )
                                        )}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MFSynopsis;






